const getters = {
  getterHelloVance(state) {
    // return state.hello + state.name;
    return state.goodsList.length;
  }
};
export default getters;
